import { IconSize } from 'components/common/types/Input.types';
import { Color } from 'lib/Button';

export enum DropdownMenuPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export interface DropdownMenuOption extends Pick<DropdownMenuBaseProps, 'icon' | 'label' | 'isSpinner'> {
  id: string;
  onClick: () => void;
  dataPendoId?: string;
  isSelected?: boolean;
  closeOnSelection?: boolean;
  iconPosition?: 'left' | 'right';
  isDisabled?: boolean;
}

export interface DropdownMenuSection {
  id: string;
  label?: string;
  options: DropdownMenuOption[];
}

interface DropdownMenuBaseProps {
  dropdownMenuPosition?: DropdownMenuPosition;
  icon?: string;
  iconSize?: IconSize.MEDIUM | IconSize.LARGE;
  label: string;
  color?: Color;
  className?: string;
  isDisabled?: boolean;
  isSpinner?: boolean;
  closeOnSelection?: boolean;
  isMenuFullWidth?: boolean;
  onOpen?: () => void;
}

export type DropdownMenuProps = DropdownMenuBaseProps &
  (
    | { dropdownMenuOptions: DropdownMenuOption[]; dropdownMenuSections?: never }
    | { dropdownMenuSections: DropdownMenuSection[]; dropdownMenuOptions?: never }
  );

export const dropdownMenuPositions: Record<DropdownMenuPosition, string> = {
  [DropdownMenuPosition.LEFT]: 'left-0',
  [DropdownMenuPosition.RIGHT]: 'right-0',
};
